<template>
  <!--Logo start-->
  <div class="logo-main">
    <img src="@/assets/images/logo.png" alt="Logo Noko"/>
  </div>
  <!--Logo End-->
</template>

<script>
export default {}
</script>
<style scoped>
.logo-main > img{
  width: 45px;
}
</style>
